/* Pawro — shared motion engine (theme asset, loaded deferred by any
   section that uses the motion system: About page sections, Contact).
   Scroll reveals via IntersectionObserver + a gentle rAF parallax for
   [data-drift]. Does nothing under prefers-reduced-motion or when no
   targets exist. Unrelated to pawro-motion.js (home page GSAP story). */
(function () {
  if (window.__pawroMotionEngine) return;
  window.__pawroMotionEngine = true;

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var reveals = document.querySelectorAll('.pawro-rv, .pawro-draw');
    var drifters = document.querySelectorAll('[data-drift]');
    if (!reveals.length && !drifters.length) return;

    document.documentElement.classList.add('pawro-motion');

    /* --- scroll reveals --- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
      );
      reveals.forEach(function (el) { io.observe(el); });

      /* anchor links can teleport the scroll position PAST reveal targets,
         so they never intersect and would stay invisible — catch up any
         element that ends fully above the viewport */
      var pending = Array.prototype.slice.call(reveals);
      var catchTicking = false;
      var catchUp = function () {
        catchTicking = false;
        for (var i = pending.length - 1; i >= 0; i--) {
          if (pending[i].classList.contains('is-in')) {
            pending.splice(i, 1);
          } else if (pending[i].getBoundingClientRect().bottom < 0) {
            pending[i].classList.add('is-in');
            io.unobserve(pending[i]);
            pending.splice(i, 1);
          }
        }
      };
      /* capture phase on document catches scroll from the window OR an inner
         wrapper (this theme scrolls .page-wrapper on desktop; scroll events
         don't bubble but do pass through the capture phase on document) */
      document.addEventListener('scroll', function () {
        if (!catchTicking) {
          catchTicking = true;
          window.requestAnimationFrame(catchUp);
        }
      }, { capture: true, passive: true });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* --- gentle parallax: measured on each element's section wrapper so
           the element's own translate never feeds back into the math --- */
    var items = [];
    drifters.forEach(function (el) {
      items.push({
        el: el,
        speed: parseFloat(el.getAttribute('data-drift')) || 0.05,
        scope: el.closest('.shopify-section') || el.parentElement
      });
    });
    if (items.length) {
      var ticking = false;
      var apply = function () {
        ticking = false;
        var vh = window.innerHeight;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].scope.getBoundingClientRect();
          if (r.bottom < -120 || r.top > vh + 120) continue;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          items[i].el.style.translate = '0 ' + (progress * items[i].speed * -100).toFixed(1) + 'px';
        }
      };
      var queue = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(apply);
        }
      };
      document.addEventListener('scroll', queue, { capture: true, passive: true });
      window.addEventListener('resize', queue, { passive: true });
      apply();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* theme editor: re-rendered sections just show, no re-observing dance */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.pawro-rv, .pawro-sig, .pawro-draw').forEach(function (el) {
      el.classList.add('is-in');
    });
  });
})();
